import React, { useEffect, useState } from 'react';
import {
  renderDropdownWithoutLabel,
  renderInputFieldWithoutLabel,
} from '../../../../common/inputField';
import { useDispatch, useSelector } from 'react-redux';
import {
  deleteEmbryologyBiopsyFiles,
  setEmbryologyBiopsyFiles,
  setEmbryologyData,
} from '../../../../actions/embryologyActions';
import { TextField } from '@mui/material';
import { fetchEmbryologyBiopsy } from '../../../../api/embryologyApi';
import { toast } from 'sonner';
import {
  emptyBiopsyRow,
  initialState,
} from '../../../../reducers/embryologyReducer';
import {
  updateFileStatusUploaded,
  uploadPatientFileApi,
} from '../../../../api/patientApi';
import { deleteFileApi } from '../../../../api/fileApi';
import FileDocumentCard from '../../../../components/FileManager/FileDocumentCard';
import FileUploadCard from '../../../../components/FileManager/FileUploadCard';
import CustomTextField from '../../../../common/CustomTextField';
import DateComponent from '../../../Registrationform/components/dateComponent';
import dayjs from 'dayjs';
import UIModal from '../../../../components/UIElements/UIModal';

const EmbryologyBiopsy = ({ cycleId, isDisabled }) => {
  const [loading, setLoading] = useState(false);
  const [files, setFiles] = useState([]);
  const [confirmModal, setConfirmModal] = useState({
    open: false,
    index: null,
  });
  const data = useSelector((state) => state.embryologyReducer);
  const biopsy = useSelector((state) => state.embryologyReducer.biopsy);
  const dispatch = useDispatch();
  useEffect(() => {
    const fetchSummary = async () => {
      dispatch(setEmbryologyData('biopsy', initialState.biopsy));
      const response = await fetchEmbryologyBiopsy(
        data.selectedPatientData.patient.id,
        cycleId,
      );

      console.log(response.data);
      if (!response.data.result) {
        return;
      }

      const oocyteRecord = response.data.result.oocyteEmbryo
        ? response.data.result.oocyteEmbryo.oocyteEmbryo
        : null;
      if (oocyteRecord) {
        const biopsyRows = [];

        for (let i = 0; i < oocyteRecord.day6.data.length; i++) {
          if (oocyteRecord.day6.data[i].fate === 'Embryobiopsy') {
            biopsyRows.push({
              ...emptyBiopsyRow,
              embryoNumber: i + 1,
              day: oocyteRecord.day6.data[i].day,
              embryoCode: oocyteRecord.day6.data[i].oocyteEmbryoCode,
              grade: oocyteRecord.day6.data[i].cellNoOrGrade,
            });
          }
        }

        if (biopsyRows.length === 0) {
          biopsyRows.push({ ...emptyBiopsyRow });
        }
        dispatch(setEmbryologyData('biopsy.rows', biopsyRows));
      } else if (response.data.result.biopsy) {
        dispatch(
          setEmbryologyData('biopsy', response.data.result.biopsy.biopsy),
        );
        dispatch(
          setEmbryologyData('biopsy.id', response.data.result.biopsy.id),
        );
      }
      toast.success('Data fetched');
    };
    fetchSummary();
  }, []);
  const handleInputChange = (e) => {
    if (isDisabled) {
      return;
    }
    const { name, value } = e.target;
    dispatch(setEmbryologyData(`biopsy.${name}`, value));
  };

  const handleAddRow = () => {
    if (isDisabled) {
      return;
    }
    const copyRows = [...biopsy.rows];
    copyRows.push({ ...emptyBiopsyRow });
    dispatch(setEmbryologyData('biopsy.rows', copyRows));
  };

  const setUploadedFiles = (files) => {
    if (isDisabled) {
      return;
    }
    dispatch(setEmbryologyBiopsyFiles(files));
  };

  const handleRowInputChange = (e, index) => {
    if (isDisabled) {
      return;
    }
    const { name, value } = e.target;
    const copyRows = biopsy.rows.map((item) => ({ ...item }));
    copyRows[index][name] = value;
    dispatch(setEmbryologyData('biopsy.rows', copyRows));
  };

  const handleTimeChange = (value, name) => {
    if (isDisabled) {
      return;
    }
    dispatch(setEmbryologyData(`biopsy.${name}`, value));
  };

  const handleDeleteRow = (index) => {
    if (isDisabled) {
      return;
    }
    const copyRows = [...biopsy.rows];
    copyRows.splice(index, 1);
    dispatch(setEmbryologyData('biopsy.rows', copyRows));
  };

  const handleDateChange = (day, name) => {
    if (isDisabled) {
      return;
    }
    dispatch(setEmbryologyData(`biopsy.${name}`, day));
  };

  const fileTag = `Embryology-Biopsy-${data.selectedPatientData.patient.id}`;
  const handleUpload = async (file, patientId) => {
    if (isDisabled) {
      return;
    }
    if (fileTag === 'Embryology-Biopsy-')
      return toast.error('Failed to upload file');
    if (!patientId) return toast.error('Patient not created');

    return new Promise((resolve, reject) => {
      try {
        setLoading(true);

        toast.promise(
          uploadPatientFileApi(
            file,
            patientId,
            'Patient',
            updateFileStatusUploaded,
            fileTag,
          ),
          {
            loading: 'Uploading file...',
            success: (data) => {
              setUploadedFiles({ fileTag: fileTag, file: data });
              setLoading(false);
              return resolve(data);
            },
            error: (err) => {
              reject('Failed to upload docs');
            },
            duration: 800,
          },
        );
      } catch (err) {
        setLoading(false);
        toast.error('Failed to upload file');
      }
    });
  };

  const handleDeleteFile = async (file) => {
    if (isDisabled) {
      return;
    }
    try {
      await deleteFileApi(
        'patient',
        data.selectedPatientData.patient.id,
        file.id,
      );
      dispatch(deleteEmbryologyBiopsyFiles(file));
      toast.success('File deleted successfully');
    } catch (err) {
      toast.error('Error deleting file');
    }
  };

  return (
    <div className="customer-profile">
      <h3 style={{ textAlign: 'center' }}>Embryo Biopsy Details</h3>
      <div className="card">
        <div className="body" style={{ display: 'flex', gap: '10px' }}>
          <table
            cellPadding={'20px'}
            style={{ flexGrow: 1, padding: '0px 10px' }}
          >
            <tbody>
              <tr>
                <td>Lab: </td>
                <td>
                  {renderInputFieldWithoutLabel(
                    'lab',
                    biopsy.lab,
                    handleInputChange,
                  )}
                </td>
              </tr>
              <tr>
                <td>Date</td>
                <td>
                  <DateComponent
                    id="embryologyDate"
                    selectedDate={biopsy.date ? dayjs(biopsy.date) : null}
                    handleDateChange={(date, dateString) =>
                      handleDateChange(date, 'date')
                    }
                  />
                </td>
                <td>Time: </td>
                <td>
                  <TextField
                    type="time"
                    variant="standard"
                    value={biopsy.time}
                    onChange={(e) => handleTimeChange(e.target.value, 'time')}
                  />
                </td>
              </tr>
              <tr>
                <td>Biopsy Sci: </td>
                <td>
                  {renderInputFieldWithoutLabel(
                    'biopsySci',
                    biopsy.biopsySci,
                    handleInputChange,
                  )}
                </td>
                <td>Witness:</td>
                <td>
                  {renderInputFieldWithoutLabel(
                    'biopsyWitness',
                    biopsy.biopsyWitness,
                    handleInputChange,
                  )}
                </td>
              </tr>
              <tr>
                <td>Tubing Sci:</td>
                <td>
                  {renderInputFieldWithoutLabel(
                    'tubingSci',
                    biopsy.tubingSci,
                    handleInputChange,
                  )}
                </td>
                <td>Witness:</td>
                <td>
                  {renderInputFieldWithoutLabel(
                    'tubingWitness',
                    biopsy.tubingWitness,
                    handleInputChange,
                  )}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <button
        className="btn btn-primary"
        style={{ width: '200px', marginBottom: '20px' }}
        onClick={handleAddRow}
      >
        Add Row
      </button>
      <div className="card">
        <div className="body" style={{ display: 'flex', gap: '10px' }}>
          <table
            style={{ flexGrow: 1, padding: '0px 10px' }}
            cellPadding={'10px'}
          >
            <thead>
              <tr>
                <th>Embryo Number</th>
                <th>Biopsy Day</th>
                <th>Embryo Code</th>
                <th>Cell#/ Grade</th>
                <th>Embryo Status</th>
                <th>DNA Detected</th>
                <th>Result of Genetic Analysis</th>
                <th>Interpretation</th>
                <th>Embryo Transfer</th>
                <th>Delete Row</th>
              </tr>
            </thead>
            <tbody>
              {biopsy.rows.map((row, index) => (
                <tr key={index}>
                  <td>
                    {renderInputFieldWithoutLabel(
                      'embryoNumber',
                      row.embryoNumber,
                      (e) => handleRowInputChange(e, index),
                    )}
                  </td>
                  <td style={{ display: 'flex' }}>
                    <CustomTextField
                      type="number"
                      onWheel={(e) => e.target.blur()}
                      value={row.day}
                      name={'day'}
                      onChange={(e) => handleRowInputChange(e, index)}
                      variant="outlined"
                      size="small"
                      fullWidth
                    />
                  </td>
                  <td>
                    {renderInputFieldWithoutLabel(
                      'embryoCode',
                      row.embryoCode,
                      (e) => handleRowInputChange(e, index),
                    )}
                  </td>
                  <td>
                    {renderInputFieldWithoutLabel('grade', row.grade, (e) =>
                      handleRowInputChange(e, index),
                    )}
                  </td>
                  <td>
                    {renderDropdownWithoutLabel(
                      'embryoStatus',
                      row.embryoStatus,
                      [' ', 'Fresh', 'Frozen'],
                      handleRowInputChange,
                      index,
                    )}
                  </td>
                  <td>
                    {renderDropdownWithoutLabel(
                      'dnaDetected',
                      row.dnaDetected,
                      [' ', 'Yes', 'No'],
                      handleRowInputChange,
                      index,
                    )}
                  </td>
                  <td>
                    {renderInputFieldWithoutLabel(
                      'resultOfGeneticAnalysis',
                      row.resultOfGeneticAnalysis,
                      (e) => handleRowInputChange(e, index),
                    )}
                  </td>
                  <td>
                    {renderDropdownWithoutLabel(
                      'interpretation',
                      row.interpretation,
                      [' ', 'Normal', 'Abnormal'],
                      handleRowInputChange,
                      index,
                    )}
                  </td>
                  <td>
                    {renderDropdownWithoutLabel(
                      'embryoTransfer',
                      row.embryoTransfer,
                      [' ', 'Yes', 'No', 'Maybe'],
                      handleRowInputChange,
                      index,
                    )}
                  </td>
                  <td style={{ margin: 0, padding: 0 }}>
                    <button
                      style={{ marginTop: '-20px' }}
                      className="btn btn-danger"
                      disabled={biopsy.rows.length === 1}
                      onClick={() => setConfirmModal({ open: true, index })}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div className="card">
        <FileUploadCard
          setFiles={setFiles}
          setUploadedFiles={setUploadedFiles}
          files={biopsy.biopsyFiles}
          handleUpload={handleUpload}
          id={data.selectedPatientData.patient.id}
          fileSelectionType="pdf/*"
        />
        {biopsy.biopsyFiles.map((uploadedFile, i) => {
          const file = uploadedFile;

          return (
            <FileDocumentCard
              key={i}
              DocumentName={file.displayFileName}
              DocumentSize={(file.size / 1024).toFixed(2) + ' KB'}
              DocumentDate={new Date(file.updatedAt).toLocaleDateString()}
              ImageUrl={
                file?.fileType?.includes('image')
                  ? file.presignedUrl
                  : undefined
              }
              handleDeleteFile={() => handleDeleteFile(file)}
              file={file}
              fileUniquePrefix={`patient-${data.selectedPatientData.patient.id}`}
            />
          );
        })}
      </div>
      <UIModal
        title="Please confirm?"
        body="Are you sure you want to delete this record?"
        proceedText="Confirm"
        cancelText="Cancel"
        show={confirmModal.open}
        onClose={() => setConfirmModal({ open: false, index: null })}
        onSave={() => {
          handleDeleteRow(confirmModal.index);
          setConfirmModal({ open: false, index: null });
        }}
      />
    </div>
  );
};

export default EmbryologyBiopsy;
